import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { NotificationService } from '@services/notification.service';
import { catchError, throwError } from 'rxjs';

export function httpErrorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const notificationService = inject(NotificationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Use a static message to avoid circular dependency with TranslateService
        notificationService.error('Session expired. Please log in again.');
        window.location.href = '/login';
        return throwError(() => error);
      }
      if (shouldHandleError(req, error)) {
        notificationService.handleHttpError(error);
      }
      console.error('HTTP Error', error);
      return throwError(() => error);
    })
  );
}

/**
 * Determine if we should show an error message for this request/error
 */
function shouldHandleError(request: HttpRequest<unknown>, _error: HttpErrorResponse): boolean {
  // Don't show errors for authentication endpoints (handled separately)
  if (request.url.includes('/auth/') || request.url.includes('/login')) {
    return false;
  }

  // Handle everything else
  return true;
}
